'use client';

import RettsstiftelsePanel, {rettsstiftelsesSort} from 'features/rettsstiftelse/components/losore/rettsstiftelse-panel';
import {RettsstiftelserWrapper} from 'features/rettsstiftelse/model/losore/rettsstiftelse';
import {useTranslation} from 'react-i18next';
import {createUseStyles} from 'react-jss';

const useStyles = createUseStyles(
  () => ({
    results: {
      marginBottom: '3rem',
    },
    rettsstiftelseCount: {
      fontWeight: '600',
      fontSize: '1rem',
    },
  }),
  {name: 'MotorvognResultSection'}
);

export const MotorvognResultSection = ({data, regnr}: {data?: RettsstiftelserWrapper; regnr: string}) => {
  const styles = useStyles();
  const {t} = useTranslation(['common', 'motorvogn']);

  return (
    <section id='results' className={styles.results}>
      <p className={styles.rettsstiftelseCount}>
        {t('motorvogn:number-of-liens', {count: data?.rettsstiftelser?.length, regnr})}
      </p>
      {!!data?.rettsstiftelser?.length &&
        data.rettsstiftelser
          .sort(rettsstiftelsesSort)
          .map((r, i) => <RettsstiftelsePanel key={`${i}-${r.dokumentnummer}`} index={i} rettsstiftelse={r} />)}
    </section>
  );
};
